import React, { useEffect, useState } from "react";
import BannerTitle from "../../common/components/BannerTitle";
import { GlobalContainer } from "../../common/components/Container";
import { StyledDataGrid } from "../../common/components/DataGrid/styles";
import { getDentists } from "../../api/dentistApi";
import CreateDentistDialog from "./components/CreateDentistDialog";
import { StyledButton } from "../../common/components/Button";
const Dentists = () => {
  const [dentists, setDentists] = useState([]);
  const [isNewDentistOpen, setNewDentistOpen] = useState();

  useEffect(() => {
    const fetchDentists = async () => {
      const { data } = await getDentists();
      setDentists(data);
    };

    fetchDentists();
  }, []);

  const handleNewDentistClick = () => {
    setNewDentistOpen(true);
  };

  const handleNewDentistClose = () => {
    setNewDentistOpen(false);
  };

  const handleNewDentistAdd = (dentist) => {
    setDentists((oldVal) => [...oldVal, dentist]);
  };

  const columns = [
    { field: "dentalClinicName", headerName: "Clinic Name", flex: 1 },
    { field: "fullName", headerName: "Dentist Name", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
  ];

  const rows = dentists.map((d) => ({
    id: d.id,
    fullName: `${d.firstName} ${d.lastName}`,
    dentalClinicName: d.dentalClinicName,
    email: d.email,
  }));

  return (
    <GlobalContainer theme="purple">
      <BannerTitle type="banner" theme="purple">
        Dentists
      </BannerTitle>
      <StyledButton theme="green" onClick={handleNewDentistClick}>
        New Dentist
      </StyledButton>
      <StyledDataGrid autoHeight rows={rows} columns={columns} />
      <CreateDentistDialog
        open={isNewDentistOpen}
        onClose={handleNewDentistClose}
        onNewDentist={handleNewDentistAdd}
      />
    </GlobalContainer>
  );
};

export default Dentists;
